var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{ref:"scrollTopButton",attrs:{"id":"to-top","title":"press to go back to top"},on:{"click":function($event){return _vm.scrollToTop()}}},[_c('font-awesome-icon',{staticClass:"margin",attrs:{"icon":"chevron-up"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }